var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4836 2.52083C19.4843 2.72324 19.4396 2.92323 19.3529 3.1061C19.2661 3.28898 19.1395 3.45009 18.9823 3.57761L10.8533 10.1215C10.6109 10.3207 10.3068 10.4297 9.99295 10.4297C9.67914 10.4297 9.37506 10.3207 9.13263 10.1215L1.0036 3.34728C0.726918 3.11732 0.552924 2.78686 0.519893 2.4286C0.486863 2.07035 0.597501 1.71364 0.82747 1.43696C1.05744 1.16028 1.3879 0.986287 1.74615 0.953257C2.10441 0.920226 2.46111 1.03086 2.73779 1.26083L9.99973 7.31696L17.2617 1.46406C17.4605 1.29839 17.7027 1.19315 17.9595 1.16079C18.2163 1.12844 18.477 1.17033 18.7108 1.2815C18.9445 1.39267 19.1415 1.56848 19.2785 1.78811C19.4154 2.00774 19.4866 2.26201 19.4836 2.52083Z",
    fill: "#3F7DBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.ca0e62ed5d8dfc51829e1de687acdee9.svg";
export { ForwardRef as ReactComponent };